import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../Support/classNames';

interface OwnProps {
    value?: {formatted: string; unit?: string};
    label: string;
    blue?: boolean;
    small?: boolean;
    className?: string;
}

export const Bucket: FunctionComponent<OwnProps> = ({value, label, blue, small, className}) => {
    return (
        <div className={classNames('bucket', {'bucket--blue': blue, 'bucket--small': small}, className)}>
            <div className="bucket__content">
                {value?.formatted ?? '-'}
                {value?.unit && <span className="bucket__unit">{value.unit}</span>}
            </div>
            <div className="bucket__label">
                <span>{label}</span>
            </div>
        </div>
    );
};
